// change container of okendo star-reviews app
(
    () => {
        const priceContainer = document.querySelector('.wt-product__info .wt-product__price')
        const shopifyAppBlock = document.querySelector('.wt-product__info .shopify-app-block:has(div[data-oke-star-rating])')
    
        if(priceContainer) priceContainer.appendChild(shopifyAppBlock);
        shopifyAppBlock.style.visibility = "visible";
    }
 )()